import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { DecisionDialogComponent } from '../shared/decision-dialog/decision-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class DecisionDialogService {

  constructor(private dialog: MatDialog, private sanitizer: DomSanitizer) {}

  openDialog(
    type: DialogType,
    title: string,
    content: string,
    width?: string
  ): MatDialogRef<DecisionDialogComponent, boolean> {
    const sanitizedContent: SafeHtml = this.sanitizer.bypassSecurityTrustHtml(content);
    return this.dialog.open(DecisionDialogComponent, {
      data: { type, title, content: sanitizedContent },
      width: width || undefined,
      ariaDescribedBy: 'dialog-content',
    });
  }

  closeAllDialogs(): void {
    this.dialog.closeAll();
  }
}

export enum DialogType {
  ERROR = 'error',
  ALERT = 'alert',
  OK = 'ok',
  CONFIRM = 'confirm', // Nuevo tipo para diálogos de confirmación
}
